import { FormField, FormHelp, Label } from '@zillow/constellation-10';
import { Controller } from 'react-hook-form';
import { date50YearsAgo, today } from '../../../../utils/formatters';
import { validateDate } from '../../../../utils/validation';
import { DatePicker } from '../../../DatePicker';

export function CurrentResidenceMovedInDate() {
  return (
    <Controller
      name="currentResidence.startDate"
      rules={{
        required: 'A moved-in date is required',
        validate: (v) =>
          validateDate(v, {
            inThePast: true,
            maxYearsAgo: 50,
          }),
      }}
      render={({ field, fieldState: { error, invalid } }) => (
        <FormField
          label={<Label id="moved-in-label">Moved in</Label>}
          description={error && <FormHelp>{error?.message}</FormHelp>}
          error={invalid}
        >
          <DatePicker {...field} minDate={date50YearsAgo()} maxDate={today()} aria-labelledby="moved-in-label" />
        </FormField>
      )}
    />
  );
}
